import { request } from "../index";
import axios from "axios";
import { getConfig } from "../../utils/config";

const baseUrl = getConfig().api.baseUrl

export function getUser() {
  return request({ url: "users/" });
}
export function getActiveBranch() {
  return request({ url: "users/get-active-branch/" });
}

export function getCodeToResetPassword(contactInfo) {
  const params = {};

  if (contactInfo.includes("@")) {
    params.email = contactInfo;
  } else {
    params.phone = contactInfo;
  }

  const axiosRequest = {
    url: `${baseUrl}/api/v1/users/reset-password/`,
    params,
  };

  return axios(axiosRequest);
}

export function resetPassword(data) {
  const axiosRequest = {
    url: `${baseUrl}/api/v1/users/reset-password/`,
    data,
    method: "POST",
  };
  return axios(axiosRequest);
}

export function getUserIndications() {
  return request({ url: "users/my-indications/" });
}
export function createInviteLink(data = {}) {
  return request({ url: "users/create-invite-code/", method: "POST", data });
}

export function updateUser(data = {}) {
  return request({ url: `users/${data.id}/`, method: "PUT", data });
}

export function processUTMData(params) {
  let url = `${baseUrl}/api/v1/users/process-utm/`;
  axios.get(url, {
    params,
  });
}



// WEBPACK FOOTER //
// ./src/api/users/index.js